import { Box } from '@chakra-ui/react';
import Field from 'components/general/Field';

function LocationForm() {
  return (
    <Box>
      <Field name="name" label="Name" register={{ required: 'Address is required' }} />
      <Field name="address" label="Address" register={{ required: 'Address is required' }} />
      <Field
        name="maxSuites"
        label="Max Suites"
        type="number"
        register={{ required: 'Max Suites is required', valueAsNumber: true }}
        mt={4}
      />
    </Box>
  );
}

export default LocationForm;
